import {SvgIcon, SvgIconProps} from "@mui/material";

export const EllipseShapeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <ellipse
            cx="12"
            cy="12"
            rx="9"
            ry="6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
        />
    </SvgIcon>
);
